import { render } from "./StoreOrderLimits.vue?vue&type=template&id=14b647f0"
import script from "./StoreOrderLimits.vue?vue&type=script&lang=js"
export * from "./StoreOrderLimits.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__